// Application settings
export const settings = {
  // PPP interpolation factor (0.0 = US prices only, 1.0 = full PPP adjustment).
  // The blend is (1 - factor) × US price + factor × raw PPP, so 0.8 keeps a
  // 0.2 weight on the US price.
  pppInterpolation: 0.8,
  // Lowest interpolated multiplier, as a share of the US price. The 0.8 blend
  // alone only stops a price at 0.2 when raw PPP is zero.
  pppMultiplierFloor: 0.5,
};
